export const choiceDialogName = 'backupDeclarationDialog';
